import { render, staticRenderFns } from "./match-ranking.vue?vue&type=template&id=aadc4f68&scoped=true&"
import script from "./match-ranking.vue?vue&type=script&lang=js&"
export * from "./match-ranking.vue?vue&type=script&lang=js&"
import style0 from "./match-ranking.vue?vue&type=style&index=0&id=aadc4f68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadc4f68",
  null
  
)

export default component.exports